module.exports = __webpack_public_path__ + "static/media/arborea6.b6d4f204.webp";